import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-8"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "shadow-box mt-3" }
const _hoisted_4 = { class: "absolute bottom-0 right-0 z-10" }
const _hoisted_5 = { class: "text-xs p-3" }
const _hoisted_6 = { class: "flex pb-1" }
const _hoisted_7 = { class: "flex-none" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_9 = { class: "flex-none" }
const _hoisted_10 = { class: "absolute top-0 right-0 z-10 graph-controls" }
const _hoisted_11 = { class: "shadow rounded-lg h-12 w-12 border-gray-200 mt-3 mr-3 border-b bg-white" }
const _hoisted_12 = { class: "shadow h-12 w-12 rounded-lg border-gray-200 mt-3 mr-3 border-b bg-white ml-auto" }
const _hoisted_13 = { class: "shadow rounded-lg h-12 w-12 border-gray-200 mt-3 mr-3 border-b bg-white" }
const _hoisted_14 = { class: "shadow h-12 w-12 rounded-lg border-gray-200 mt-3 mr-3 border-b bg-white ml-auto" }
const _hoisted_15 = {
  ref: "graph",
  class: "h-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowsExpandIcon = _resolveComponent("ArrowsExpandIcon")!
  const _component_XCircleIcon = _resolveComponent("XCircleIcon")!
  const _component_LocationMarkerIcon = _resolveComponent("LocationMarkerIcon")!
  const _component_ZoomInIcon = _resolveComponent("ZoomInIcon")!
  const _component_ZoomOutIcon = _resolveComponent("ZoomOutIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.errorMsg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.errorMsg), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["bg-white", {
            fixed: _ctx.isFullScreen,
            '2xl:w-3/4': _ctx.isFullScreen && _ctx.slotHasContent,
            'lg:w-2/3': _ctx.isFullScreen && _ctx.slotHasContent,
            'w-full': _ctx.isFullScreen,
            'h-full': _ctx.isFullScreen,
            'top-0': _ctx.isFullScreen,
            'right-0': _ctx.isFullScreen,
            relative: !_ctx.isFullScreen,
            'h-96': !_ctx.isFullScreen
          }])
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(Math.floor(_ctx.minDate)), 1),
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, _toDisplayString(Math.floor(_ctx.maxDate)), 1)
                  ]),
                  _createElementVNode("div", {
                    style: _normalizeStyle({
                  background:
                    'linear-gradient(90deg, hsl(259, 92.7%, 80%), hsl(259, 92.7%, 20%))'
                }),
                    class: "w-56 h-3"
                  }, null, 4)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    class: "justify-center p-3",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFullScreen && _ctx.toggleFullScreen(...args)))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass({ hidden: _ctx.isFullScreen })
                    }, [
                      _createVNode(_component_ArrowsExpandIcon, { class: "h-6 w-6" })
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass({ hidden: !_ctx.isFullScreen })
                    }, [
                      _createVNode(_component_XCircleIcon, { class: "h-6 w-6" })
                    ], 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    class: "justify-center p-3",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.centerGraph && _ctx.centerGraph(...args)))
                  }, [
                    _createVNode(_component_LocationMarkerIcon, { class: "h-6 w-6" })
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    class: "justify-center p-3",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.zoomIn && _ctx.zoomIn(...args)))
                  }, [
                    _createVNode(_component_ZoomInIcon, { class: "h-6 w-6" })
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", {
                    class: "justify-center p-3",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.zoomOut && _ctx.zoomOut(...args)))
                  }, [
                    _createVNode(_component_ZoomOutIcon, { class: "h-6 w-6" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, null, 512)
            ], 2)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["bg-white", {
          'lg:overflow-scroll': _ctx.isFullScreen && _ctx.slotHasContent,
          'lg:fixed': _ctx.isFullScreen && _ctx.slotHasContent,
          '2xl:w-1/4': _ctx.isFullScreen && _ctx.slotHasContent,
          'lg:w-1/3': _ctx.isFullScreen && _ctx.slotHasContent,
          'lg:h-full': _ctx.isFullScreen && _ctx.slotHasContent,
          'lg:top-0': _ctx.isFullScreen && _ctx.slotHasContent,
          'lg:left-0': _ctx.isFullScreen && _ctx.slotHasContent,
          'lg:pl-2': _ctx.isFullScreen && _ctx.slotHasContent,
          'lg:pr-2': _ctx.isFullScreen && _ctx.slotHasContent,
          relative: !_ctx.isFullScreen && _ctx.slotHasContent
        }])
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 2)
        ]))
  ]))
}